import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FaDollarSign } from "react-icons/fa";
import cn from "classnames";

import { Page, Input } from "ui/components";
import { Leg } from "services/action";

import epod from "ui/assets/epod.png";

const CollectScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);

  const {
    manifest_id,
    leg_id,
    cod_value
  } = location?.state;

  const [cod, setCOD] = React.useState();

  const $onSave = async (e) => {
    let payload = {
      cod_receive: cod,
    };

    const req = await Dispatch(Leg.$collected(manifest_id, leg_id, payload));

    if (req?.message === "success") {
      History.goBack();
    }
  };

  React.useEffect(() => {
    setCOD(cod_value)
  }, [cod_value]);

  return (
    <Page
      title={<img src={epod} alt="" height={25} />}
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100 fs-7",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onSave}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="py-3">
        <div>COD Terima:</div>
        <div className="form-group mv-3">
          <Input
            icon={<FaDollarSign />}
            value={cod}
            onChange={(e) => {
              setCOD(e.target.valueAsNumber);
            }}
            type="number"
            placeholder="masukkan nilai cod diterima"
            error={StateForm?.errors?.cod_receive}
            lg
          />
        </div>
      </div>
    </Page>
  );
};

export default CollectScreen;
